import OfferEstimator from './OfferEstimator';
import shared from '@/styles/public.module.css';
import styles from './HeroSection.module.css';

const CHIPS = ['Free to apply', 'No monthly payments', 'Lose the case, owe $0'];

// Deliberately terse — this previews "How it works" rather than repeating it.
const STEPS = [
  { lead: 'You apply.', rest: 'About five minutes, no documents to dig up.' },
  { lead: 'We reach out to your attorney.', rest: 'Not you — we handle the verification.' },
  {
    lead: 'Funders bid.',
    rest: 'Compare the totals and pick one, or turn them all down.',
  },
];

const HeroSection = () => (
  <header className={styles.hero} data-testid="hero-section">
    <div className={`${shared.wrap} ${styles.grid}`}>
      <div className={styles.left} data-testid="hero-content">
        <span className={styles.eyebrow}>
          Pre-settlement funding · No credit check
        </span>
        <h1 className={styles.title}>
          Money now, while your case is <em>still open</em>.
        </h1>
        <p className={styles.sub}>
          Apply once and verified funders compete for your case. You pick the offer
          that costs you least. If you lose, you owe nothing.
        </p>

        <ul className={styles.chips} data-testid="hero-trust-badges">
          {CHIPS.map((chip) => (
            <li key={chip} className={styles.chip}>
              {chip}
            </li>
          ))}
        </ul>

        <ol className={styles.steps}>
          {STEPS.map((step, i) => (
            <li key={step.lead} className={styles.step}>
              <span className={styles.stepNum} aria-hidden="true">
                {i + 1}
              </span>
              <p>
                <b>{step.lead}</b> {step.rest}
              </p>
            </li>
          ))}
        </ol>
      </div>

      <div data-testid="hero-visual">
        <OfferEstimator />
      </div>
    </div>
  </header>
);

export default HeroSection;
